import React from 'react';
import Text from './text';

export default function TextWrapper({
  children,
}: React.ComponentProps<typeof Text>) {
  return children;
}
